import { connect } from 'react-redux'
import { actionCreators } from 'src/state/actions/organizations'

import Promotions from '../../components/promotions/Promotions'
import { fetchServiceList } from '../../state/actions/services'

import { IPromotionFilter, IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState) => {
  const currentOrgId: string = state.organizations.currentOrgId as string

  return {
    currentOrgId
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchServices: (orgId: string) => {
      dispatch(fetchServiceList('active', orgId))
    },
    updatePromotionFilters: (params: IPromotionFilter) => dispatch(actionCreators.updatePromotionFilters(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Promotions)



// WEBPACK FOOTER //
// ./src/containers/promotions/Promotions.ts